import { Image } from 'expo-image';
import { useState } from 'react';

import { useSizedImageUrl } from '@/util/imageWidths';

/** Widest an article body is laid out, which bounds its images. */
const ARTICLE_MAX_WIDTH = 768;

/**
 * An article image drawn at full width with its own aspect ratio. The ratio
 * comes from the loaded image rather than a separate size probe, which used to
 * download every image twice.
 */
export const AutoSizedImage = ({ alt, imageUrl }: { alt: string; imageUrl: string }) => {
  const [aspectRatio, setAspectRatio] = useState(1);

  const source = useSizedImageUrl(imageUrl, ARTICLE_MAX_WIDTH);

  return (
    <Image
      alt={alt}
      contentFit="cover"
      onLoad={({ source: loaded }) => {
        if (loaded.width > 0 && loaded.height > 0) {
          setAspectRatio(loaded.width / loaded.height);
        }
      }}
      source={source}
      style={{
        aspectRatio,
        width: '100%',
      }}
    />
  );
};
